/**
 * Every source an estimate can carry.
 *
 * NOT-584 (A2) — `source` records the MECHANISM that made the row (office
 * create, proposal, job, Iris, inbound lead), and the system knows it with
 * certainty at creation. No human ever picks it, so this list exists to LABEL a
 * stored value and nothing else — there is no picker to build from it.
 *
 * The distinction that used to live here (pickable vs system-stamped) is gone
 * because the pickable half is gone: a dropdown let a human write "AI" onto an
 * estimate a person typed, and `source` is what Iris's attribution metrics
 * (NOT-562) count. A field the system can derive is not a question worth asking.
 */
export const ALL_ESTIMATE_SOURCES: { value: string; label: string }[] = [
  { value: 'MANUAL', label: 'Manual' },
  { value: 'PROPOSAL', label: 'Proposal' },
  { value: 'JOB', label: 'Job' },
  { value: 'AI', label: 'AI' },
  { value: 'OTHER', label: 'Other' },
  { value: 'INBOUND_LEAD', label: 'Inbound Lead' },
];

export function formatEstimateSource(value?: string | null): string {
  if (!value) return '-';
  return (
    ALL_ESTIMATE_SOURCES.find((option) => option.value === value)?.label ??
    value
      .split('_')
      .map((part) => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
      .join(' ')
  );
}
